module.exports = __webpack_public_path__ + "media/floorPlans/floorPlansCover-3c904b27.png";